import useSWR from 'swr';

import { fetchData } from '@/helpers/swr';
import { useListEntryCompare } from '@/helpers/_hooks';

// The recently-accessed carousel shows at most the ten most-recent estimates.
const RECENT_ESTIMATE_LIMIT = 10;

const recentEstimatesKey = (limit = RECENT_ESTIMATE_LIMIT) => `/recent-estimate?limit=${limit}`;

const useRecentEstimates = (limit = RECENT_ESTIMATE_LIMIT) => {
  const swr = useSWR(recentEstimatesKey(limit), fetchData);
  return swr;
};

const useRecentEstimateObject = (uid, limit = RECENT_ESTIMATE_LIMIT) => {
  const recentEstimates = useSWR(recentEstimatesKey(limit), fetchData, { compare: useListEntryCompare(uid) });
  return recentEstimates.data.content[uid];
};

export { useRecentEstimates, useRecentEstimateObject };
